/** Reset-password policy: ≥8 chars, upper, lower, digit, special (matches backend). */
export const RESET_PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export type ResetPasswordRequirementKey =
  | "minLength"
  | "uppercase"
  | "lowercase"
  | "number"
  | "special";

export type ResetPasswordRequirement = {
  key: ResetPasswordRequirementKey;
  labelKey: string;
  met: boolean;
};

export type ResetPasswordStrength = "weak" | "medium" | "strong";

export function getResetPasswordRequirements(
  password: string
): ResetPasswordRequirement[] {
  return [
    {
      key: "minLength",
      labelKey: "resetPassword.requirements.minLength",
      met: password.length >= 8,
    },
    {
      key: "uppercase",
      labelKey: "resetPassword.requirements.uppercase",
      met: /[A-Z]/.test(password),
    },
    {
      key: "lowercase",
      labelKey: "resetPassword.requirements.lowercase",
      met: /[a-z]/.test(password),
    },
    {
      key: "number",
      labelKey: "resetPassword.requirements.number",
      met: /\d/.test(password),
    },
    {
      key: "special",
      labelKey: "resetPassword.requirements.special",
      met: /[^A-Za-z0-9]/.test(password),
    },
  ];
}

export function isResetPasswordPolicyValid(password: string): boolean {
  return RESET_PASSWORD_REGEX.test(password);
}

export function getResetPasswordStrength(
  password: string
): ResetPasswordStrength {
  if (!password) {
    return "weak";
  }

  const requirements = getResetPasswordRequirements(password);
  const metCount = requirements.filter((r) => r.met).length;

  if (metCount >= 5 && password.length >= 12) {
    return "strong";
  }

  if (metCount >= 3) {
    return "medium";
  }

  return "weak";
}
